import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClientConfig } from "./queries/config/queryClientConfig";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { BrowserRouter } from "react-router-dom";
import { LoadingProvider } from "./context/loadingContext";
//import { UsuarioProvider } from "./context/usuarioContext";

// import "./style.scss";

const rootNode = document.getElementById("root");
const root = createRoot(rootNode);
root.render(
  <QueryClientProvider client={queryClientConfig}>
    <LoadingProvider>
      <BrowserRouter>
        <App />
        {/* <ReactQueryDevtools initialIsOpen={true} /> */}
      </BrowserRouter>
    </LoadingProvider>
  </QueryClientProvider>
);
